import { useState } from 'react'
import {
  getExtendedForm2PaymentInstructions,
  getExtendedForm2QrSrc,
  EXTENDED_FORM2_UPI_ID,
} from '../../utils/eventRegistrationFormTypes'

export default function ExtendedForm2PaymentSection({
  fee,
  transactionId,
  onTransactionIdChange,
  disabled,
}) {
  const [copied, setCopied] = useState(false)

  const copyUpi = async () => {
    try {
      await navigator.clipboard.writeText(EXTENDED_FORM2_UPI_ID)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {
      /* ignore */
    }
  }

  return (
    <>
      <div className="rounded-xl border border-primary-200 bg-white p-3">
        <p className="text-sm font-medium text-gray-800 mb-2">
          {getExtendedForm2PaymentInstructions(fee)}
        </p>
        <img
          src={getExtendedForm2QrSrc()}
          alt="Payment QR code"
          className="w-full max-w-[260px] mx-auto rounded-lg border border-gray-200"
          loading="lazy"
        />
        {/* <div className="mt-3 flex flex-col sm:flex-row sm:items-center sm:justify-center gap-2 text-sm text-gray-700">
          <span>
            UPI ID: <span className="font-mono font-medium">{EXTENDED_FORM2_UPI_ID}</span>
          </span>
          <button
            type="button"
            onClick={copyUpi}
            className="text-primary-600 font-semibold hover:text-primary-700 underline-offset-2 hover:underline min-h-[44px] sm:min-h-0 py-2 sm:py-0"
          >
            {copied ? 'Copied' : 'Copy UPI ID'}
          </button>
        </div> */}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Payment Transaction ID <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          placeholder="Enter your UPI transaction ID"
          value={transactionId}
          onChange={(e) => onTransactionIdChange(e.target.value)}
          required
          disabled={disabled}
          className="w-full px-3 py-2.5 rounded-lg border border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
        />
      </div>
    </>
  )
}
